import axios from "axios";
import { getEnvVariable } from "@/api/axios";
import { AddressInterface, GeoCoordinatesInterface } from "@/api/Interfaces/MapInterface";
import { ErrorHandler } from "vue-router/types/router";

type errorHandling = (error: any) => any;

export default class MapService {
  static VUE_APP_HERE_API_KEY = '';

  static async getZipCode(apiUrl: any) {
    const { data } = await axios.get(apiUrl);

    if (data.cep || data.code) {
      return data;
    }

    return {};
  }

  static async getLocationByZipCode(
    zipCode: string
  ): Promise<AddressInterface | ErrorHandler | boolean | void> {
    const apiUrl = [
      `https://viacep.com.br/ws/${zipCode}/json/`,
      `https://brasilapi.com.br/api/cep/v1/${zipCode}`,
      `https://ws.apicep.com/cep/${zipCode}.json`,
    ];

    const maxRandomRange = apiUrl.length - 1;
    let apiOptions = [];
    let currentApiIndex = Math.floor(Math.random() * (maxRandomRange + 1));
    let formatedResponse: any = {};

    for (let index = 0; index <= maxRandomRange; index++) {
      if (index != currentApiIndex) apiOptions.push(index);
    }

    do {
      const currentApi = apiUrl[currentApiIndex];
      const responseLocation = await this.getZipCode(currentApi);
      formatedResponse = this.formatResponseByZipCodeApi(currentApiIndex, responseLocation);
      currentApiIndex = apiOptions[Math.floor(Math.random() * apiOptions.length)];
      apiOptions = apiOptions.filter((el) => {
        return el != currentApiIndex;
      });
    } while (apiOptions.length > 0 && (!formatedResponse.state || !formatedResponse.city));

    return formatedResponse;
  }

  static formatResponseByZipCodeApi(apiIndex: number, responseData: any) {
    switch (apiIndex) {
      case 0: {
        // url: https://viacep.com.br/ws/${zipCode}/json/
        return {
          city: responseData.localidade,
          neighboorhood: responseData.bairro,
          postalCode: responseData.cep,
          state: responseData.uf,
          street: responseData.logradouro,
        };
      }
      case 1: {
        // url: https://brasilapi.com.br/api/cep/v1/${zipCode}
        return {
          city: responseData.city,
          neighboorhood: responseData.neighborhood,
          postalCode: responseData.code,
          state: responseData.state,
          street: responseData.street,
        };
      }
      case 2: {
        // url:https://ws.apicep.com/cep/${zipCode}.json
        return {
          city: responseData.city,
          neighboorhood: responseData.district,
          postalCode: responseData.code,
          state: responseData.state,
          street: responseData.address,
        };
      }
      default:
        return {};
    }
  }

  static async getGeoCoordinatesByAddress(
    address: any,
    errorHandling?: errorHandling
  ): Promise<GeoCoordinatesInterface | ErrorHandler | void> {
    if (address.street || address.city) {
      const formattedAddress = `${address.street}, ${address.number ? address.number : 0}, ${
        address.city
      }, ${address.state}`;
      MapService.VUE_APP_HERE_API_KEY = await getEnvVariable("VUE_APP_HERE_API_KEY", 5);
      const url = `https://geocode.search.hereapi.com/v1/geocode?q=${formattedAddress}&lang=pt-BR/&apiKey=${MapService.VUE_APP_HERE_API_KEY}`;

      return axios
        .get(url)
        .then((response) => {
          const geoCoordinates: GeoCoordinatesInterface = {
            latitude: response.data.items[0].position.lat,
            longitude: response.data.items[0].position.lng,
          };

          return geoCoordinates;
        })
        .catch((error) => {
          if (errorHandling) {
            errorHandling(error);
          } else {
            this.errorDefaultMessage(error);
          }
        });
    } else {
      if (errorHandling) {
        errorHandling(address);
      } else {
        this.errorDefaultMessage(address);
      }
    }
  }

  static async getAddressByGeoCoordinates(
    latitude: string | number,
    longitude: string | number,
    errorHandling?: errorHandling
  ): Promise<AddressInterface | ErrorHandler | void> {
    MapService.VUE_APP_HERE_API_KEY = await getEnvVariable("VUE_APP_HERE_API_KEY", 5);
    const url = `https://revgeocode.search.hereapi.com/v1/revgeocode?at=${latitude},${longitude}&lang=pt-BR/&apiKey=${MapService.VUE_APP_HERE_API_KEY}`;

    return axios
      .get(url)
      .then((response) => {
        const address: AddressInterface = {
          city: response.data.items[0].address.city,
          neighboorhood: response.data.items[0].address.district,
          postalCode: response.data.items[0].address.postalCode,
          state: response.data.items[0].address.state,
          street: response.data.items[0].address.street,
        };

        return address;
      })
      .catch((error) => {
        if (errorHandling) {
          errorHandling(error);
        } else {
          this.errorDefaultMessage(error);
        }
      });
  }

  static errorDefaultMessage(error: any): void {
    console.error("%c Pending error handling => ", "font-weight: bold", error);
    throw new Error("%c Pending error handling => " + error.message);
  }
}
